export enum ComissionFrequency {
  REGULAR = "regular",
  IRREGULAR = "irregular",
}
